// Payment command identity + operator-facing state messages (server is the authority).
export const newPaymentKey = () =>
  (window.crypto?.randomUUID ? window.crypto.randomUUID() : `pk-${Date.now()}-${Math.random().toString(36).slice(2)}`);

const TITLES = {
  PERMISSION_DENIED: 'Permission denied',
  PREVIEW_LIVE_WRITE_BLOCKED: 'Blocked in this environment',
  ENVIRONMENT_UNCLASSIFIED: 'Blocked in this environment',
  COMMAND_OUTCOME_UNKNOWN: 'Outcome unknown — needs reconciliation',
  COMMAND_PROCESSING: 'Still processing',
  IDEMPOTENCY_KEY_REUSED: 'Request changed',
  SUSPECTED_REPEAT: 'Possible repeat payment',
  COMMAND_RESOLVED_NOT_APPLIED: 'Resolved as not applied',
};

export const paymentCommandError = (err, fallback = 'Payment failed') => {
  const d = err?.response?.data?.detail;
  if (d && typeof d === 'object') {
    const code = d.code || '';
    return { code, title: TITLES[code] || 'Payment not recorded', message: d.message || fallback };
  }
  return { code: '', title: 'Payment not recorded', message: typeof d === 'string' ? d : fallback };
};
